import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IClickLayerConfiguration, IClickLayerProps, IClickLayerState } from './models/index.js';
import { CLICK_LAYER_CATEGORY_KEY, CLICK_LAYER_COMPONENT_KEY } from './ClickLayer.meta.js';

const rawCssPrefix = `
position: fixed;
top: 0;
bottom: 0;
left: 0;
right: 0;
`;
export class ClickLayer extends ComponentBase<IClickLayerProps, IClickLayerState, IClickLayerConfiguration> {
	categoryKey = CLICK_LAYER_CATEGORY_KEY;
	componentKey = CLICK_LAYER_COMPONENT_KEY;

	constructor(props: IClickLayerProps) {
		super(props);
	}
	render() {
		const { className, onClick } = this.props;
		return (
			<div
				className={className}
				onClick={(e: any) => {
					e.stopPropagation();
					if (onClick) {
						onClick(e);
					}
				}}
			/>
		);
	}
}

export default InjectedStyledComponent(
	observer(ClickLayer),
	CLICK_LAYER_CATEGORY_KEY,
	CLICK_LAYER_COMPONENT_KEY,
	undefined,
	rawCssPrefix,
);
